const API_HOSTNAME = '/brcapi';
const bpiam = 'bpiamx';
const brain = 'brain';
const marketing = 'marketing';
const knowledge = 'knowledge';

export const APIHOSTNAME = API_HOSTNAME;
export const APIHOSTVISUALIZE = `${API_HOSTNAME}/api`;
export const BPIAM_API = `${API_HOSTNAME}/${bpiam}/api`;
export const BRAIN_API = `${API_HOSTNAME}/${brain}/api`;
export const MARKETING_API = `${API_HOSTNAME}/${marketing}/api`;
// export const MARKETING_API = `/${marketing}/api`;
export const KNOWLEDGE_API = `${API_HOSTNAME}/${knowledge}`;
export const OSS_API = `${API_HOSTNAME}/oss/api/oss/`;
export const KNOWLEDGE = `${API_HOSTNAME}/knowledge/api/`;
export const AISMLLMAPI = `/aismllmapi/vector_db/`; // pyhont 服务
export const WPSLoginAPI = `${API_HOSTNAME}/aism-sdk/api`;
export const WPSKnowledgeBaseAPI = `${API_HOSTNAME}/marketing/api/wps/knowledge-base`;
// export const WPSKnowledgeBaseAPI = `/marketing/api/wps/knowledge-base`;
